import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// comment if no orm
import "./scss/main.scss";

import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import { RootState, store } from "./store/store";

import { Provider, useDispatch, useSelector } from "react-redux";
import {
  setLanguage,
  setStationPickerOptions,
  getParameter,
} from "./store/app/general";
import { setSid } from "./store/orm/userSession";

import GoogleMapsProvider from "./GoogleMapsProvider";

// uncomment if no orm
// import "./scss/main_noorm.scss";

import App from "./App";
// import reportWebVitals from "./reportWebVitals";

import apiService, { APIResponse } from "./hooks/api/axios";
import ormcoreService from "./hooks/api/ormcore";
import ormStationsService from "./hooks/api/stations";
import ormVehiclesService from "./hooks/api/vehicles";

// import { useJsApiLoader } from "@react-google-maps/api";
// import userSession from "./hooks/app/userSession";
// const dispatch = useDispatch();

// Find all widget divs
const widgetDivs = document.querySelectorAll(".orm-widget");

async function initializeAPI() {
  try {
    const appCode = process.env.REACT_APP_AUTHCODE as string;
    if (process.env.NODE_ENV === "development") {
      await apiService.fetchApiUrl(appCode);
    } else {
      await apiService.fetchApiUrlCDN();
    }
  } catch (error) {
    console.error("API Initialisierung fehlgeschlagen:", error);
  }

  store.dispatch(setSid());
}

function GlobalOptionsInitializer() {
  widgetDivs.forEach((div) => {
    const myEle = div as HTMLElement;
    if (myEle.dataset.symbol === "globalConfig") {
      if (myEle.dataset.lang) {
        store.dispatch(setLanguage(myEle.dataset.lang));
      }
      const options = {
        useinputsearch: true,
        useapi: true,
        regioncodes: ["DE"],
        rangelimit: 50,
        resultlimit: 0,
      };

      if (myEle.dataset.useinputsearch) {
        options.useapi = myEle.dataset.useinputsearch === "true" ? true : false;
      }
      if (myEle.dataset.useapi) {
        options.useapi = myEle.dataset.useapi === "true" ? true : false;
      }
      if (myEle.dataset.regioncodes) {
        const regionCodes = myEle.dataset.regioncodes
          ? myEle.dataset.regioncodes.split(",") || ["DE"]
          : ["DE"];
        options.regioncodes = regionCodes;
      }
      if (myEle.dataset.rangelimit) {
        options.resultlimit = parseInt(myEle.dataset.rangelimit);
      }
      if (myEle.dataset.resultlimit) {
        options.resultlimit = parseInt(myEle.dataset.resultlimit);
      }

      store.dispatch(setStationPickerOptions(options));
    }
  });

  const myEle = document.getElementById("crentReservation");
  if (myEle !== null) {
    if (myEle.dataset.lang) {
      store.dispatch(setLanguage(myEle.dataset.lang));
    }
    const options = {
      useinputsearch: true,
      useapi: true,
      regioncodes: ["DE"],
      rangelimit: 50,
      resultlimit: 0,
    };

    if (myEle.dataset.useinputsearch) {
      options.useapi = myEle.dataset.useinputsearch === "true" ? true : false;
    }
    if (myEle.dataset.useapi) {
      options.useapi = myEle.dataset.useapi === "true" ? true : false;
    }
    if (myEle.dataset.regioncodes) {
      const regionCodes = myEle.dataset.regioncodes
        ? myEle.dataset.regioncodes.split(",") || ["DE"]
        : ["DE"];
      options.regioncodes = regionCodes;
    }
    if (myEle.dataset.rangelimit) {
      options.resultlimit = parseInt(myEle.dataset.rangelimit);
    }
    if (myEle.dataset.resultlimit) {
      options.resultlimit = parseInt(myEle.dataset.resultlimit);
    }

    store.dispatch(setStationPickerOptions(options));
  }
}

function loadWidgets() {
  let apiKey = getParameter(store.getState(), "SGOOGLE_MAPS_APIKEY");
  // if (apiKey == "") apiKey = "AIzaSyC0RHyEWcLIrqbm4AtNpMKzkYCf-rnKlP0";
  const googleMapsRoot = document.createElement("div");
  document.body.appendChild(googleMapsRoot);
  const gmRoot = ReactDOM.createRoot(googleMapsRoot);

  gmRoot.render(
    <Provider store={store}>
      <GoogleMapsProvider apiKey={apiKey} />
    </Provider>,
  );

  // Inject our React App into each class
  widgetDivs.forEach((div) => {
    const element = div as HTMLElement;
    if (element.dataset.symbol === "globalConfig") return;
    const root = ReactDOM.createRoot(div as HTMLElement);
    root.render(
      // <React.StrictMode>
      <Provider store={store}>
        <App symbol={element.dataset.symbol} dataset={element.dataset} />
      </Provider>,
      // </React.StrictMode>,
    );
  });
}

async function initORM() {
  await initializeAPI();

  // GlobalOptionsInitializer();
  // await ormcoreService.fetchModules();
  // await ormcoreService.fetchParameters();
  // await ormcoreService.fetchTranslations();
  ormStationsService.fetchStations();
  // ormVehiclesService.fetchVehicles();
  loadWidgets();
}

initORM();
